// eslint-disable-next-line import/no-cycle
import { ButtonFieldConfigOption, ComponentNameEnum, SmartProductListLayoutEnum } from '@/types';

const getSpmIconsFieldConfig = (iconList: string[] = [], pattern = '', property = 'spm_icon-', defaultValue = '', valuesToAskConfirmation: string[] = []) => ({
  componentName: ComponentNameEnum.BUTTON_GROUP,
  options: iconList.reduce<Record<string, ButtonFieldConfigOption>>((acc, current) => ({
    ...acc,
    [current]: {
      title: '',
      src: pattern.replace('{key}', current),
      value: '',
      defaultValue,
      property,
      iconClass: current === SmartProductListLayoutEnum.CUSTOM ? 'fa-sharp fa-solid fa-pen-to-square fa-lg' : '',
      askConfirmation: valuesToAskConfirmation.includes(current),
    },
  }), {}),
});

export default getSpmIconsFieldConfig;
